import { Component, LOCALE_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CV } from '../../models/cv.model';
import { CVService } from '../../services/cv.service';

@Component({
  selector: 'app-verified-cv',
  standalone: false,
  templateUrl: './verified-cv.component.html',
  providers: [
    { provide: LOCALE_ID, useValue: 'en-US' } // or any fixed locale
  ]
})
export class VerifiedCvComponent {

  cvDetails!: CV;
  dataLoading = false;
  applicantId!: any;

  isVerified = false;
  isCompetencyCV = false;

  constructor(
    private service: CVService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.applicantId = params.get('id');
      }
      if (params.get('type')) {
        this.isCompetencyCV = true;
      } else {
        this.isCompetencyCV = false;
      }
    });
  }

  ngOnInit(): void {
    this.getPersonalCV();
  }

  formattedCV(text: string) {
    return text?.replace(/\n/g, '<br>');
  }

  getPersonalCV() {
    this.dataLoading = true;
    if (!this.applicantId) return;
    this.service.checkApplicantCV(this.applicantId).subscribe((res: any) => {
      this.cvDetails = res.data;
      this.dataLoading = false;
      if (res.status == 200) {
        this.isVerified = true;
      } else {
        this.isVerified = false;
      }
    }, (err: any) => {
      this.isVerified = false;
      this.dataLoading = false;
    })
  }
}
